import React, {useCallback, useEffect} from "react";
import {useParams} from "react-router-dom";
import {useTypedSelector} from "../../../../redux/Hooks/storeSelectors";
import {selectDrawnFeatures, selectMapLayerIdByEntityName} from "../../../../redux/selectors/selectors";
import EntityEditor from "../../../../components/Entities/EntityEditor";
import EntityManagerCleaner from "../../../../components/Entities/EntityManagerCleaner";
import {FeatureProperties, FeatureState} from "../../../../redux/map/types";
import {useEntityLoader} from "../../../../hooks/entites/useEntityLoader";
import {requireToHighlightFeatures} from "../../../../redux/map/map-reducer";
import {useDispatch} from "react-redux";
import mapApi from "../../../../api/mapApi";
import {isEmptyResponse, isErrorResponse} from "../../../../utils/utils";
import {RoadInfrastructureEntityName} from "../../../../api/types/types";


const RoadSegmentEdit = () => {
    const entityName = RoadInfrastructureEntityName.RoadSegment;
    const {roadSegmentId, roadId} = useParams<any>();
    const sourceId = useTypedSelector((state) => selectMapLayerIdByEntityName(state, entityName));
    const dispatch = useDispatch();

    const saveFnArgs = useCallback((entity: any) => ({
        roadInfrastructureRoad: {id: roadId}
    }), [roadId]);

    const drawnFeatures = useTypedSelector(selectDrawnFeatures) as GeoJSON.Feature<any, Partial<FeatureProperties>>[];
    const {saveFn} = useEntityLoader({entityName, saveFnArgs, presetProperty: 'roadInfrastructurePreset'});

    const onSaveFn = useCallback(async (entity: any) => {
        //TODO this is a workaround to save 2nd segment after cut. Ideally should be improved
        if (drawnFeatures.length > 1) {
            const abortController = new AbortController();
            const {id, ...newEntity} = entity;
            newEntity['geometryJson'] = JSON.stringify(drawnFeatures?.[1]);
            await saveFn({entityName, data: newEntity, abortSignal: abortController.signal});
        }

        if (!roadSegmentId) {
            return `../${entity.id}/edit`;
        }
    }, [entityName, roadSegmentId, drawnFeatures]);

    useEffect(() => {
        dispatch(requireToHighlightFeatures({
            featureProperties: []
        }));

        void (async function () {
            const abortController = new AbortController();

            if (roadSegmentId) {
                const feature = await mapApi.getFeatureById(roadSegmentId, entityName, abortController.signal);
                // currently backend allows to save segment without geometry => empty response
                if (!isErrorResponse(feature) && !isEmptyResponse(feature as unknown as string)) {
                    const {properties: {id, featureStateId}} = feature;
                    dispatch(requireToHighlightFeatures({
                        featureProperties: {
                            id,
                            featureStateId: featureStateId.toString(),
                            layerId: sourceId,
                            entityName,
                            stateProperty: FeatureState.HIGHLIGHTED
                        }
                    }));
                }
            }
        }());
    }, [entityName, sourceId, roadSegmentId]);

    const onDeleteFn = useCallback(() => '../../', []);

    return (
        <EntityManagerCleaner entityName={entityName}>
            <EntityEditor
                entityId={roadSegmentId!}
                entityName={entityName}
                layerId={sourceId}
                saveFnArgs={saveFnArgs}
                presetProperty={'roadInfrastructurePreset'}
                undoLastActionBtn={true}
                getUrlOnSaveFn={onSaveFn}
                getUrlOnDeleteFn={onDeleteFn}
                showDeleteBtn={!!roadSegmentId}
            />
        </EntityManagerCleaner>
    )
}

export default RoadSegmentEdit;